<template>
  <div class="editPostIndex2">
    <div class="cont">
      <div v-if="jobInfo">
        <div class="topBox">
          <div class="name">
            {{ jobInfo.positionName }}
            <span>{{ jobInfo.branch }}</span>
            <span style="margin-left: 10px">{{ jobInfo.createTime }}</span>
            <span style="margin-left: 10px"
              >{{ '猎头费:'
              }}{{
                ((Number(jobInfo.salaryMax) + Number(jobInfo.salaryMin)) * 9) /
                  100 +
                'w'
              }}</span
            >
          </div>
          <div class="info">
            {{ jobInfo.provinceName }}{{ ' ' }}|{{ ' ' }}{{ jobInfo.cityName
            }}{{ ' ' }}|{{ ' ' }}{{ jobInfo.areaName }}{{ ' ' }}|{{ ' ' }}
            <span
              v-if="jobInfo.workingLifeMin > 10 && jobInfo.workingLifeMax > 10"
              >10年以上</span
            >
            <span
              v-if="jobInfo.workingLifeMin < 11 && jobInfo.workingLifeMax > 10"
              >{{ jobInfo.workingLifeMin }}年以上</span
            >
            <span
              v-if="
                jobInfo.workingLifeMin !== jobInfo.workingLifeMax &&
                jobInfo.workingLifeMin < 11 &&
                jobInfo.workingLifeMax < 11
              "
              >{{ jobInfo.workingLifeMin }}~{{ jobInfo.workingLifeMax }}年</span
            >
            <span
              v-if="
                jobInfo.workingLifeMin === jobInfo.workingLifeMax &&
                jobInfo.workingLifeMin < 11
              "
              >{{ jobInfo.workingLifeMin }}年</span
            >
            {{ ' ' }}|{{ ' 年薪:' }}
            {{
              jobInfo.minYearSalary === jobInfo.maxYearSalary
                ? jobInfo.minYearSalary + 'w'
                : jobInfo.minYearSalary + '~' + jobInfo.maxYearSalary + 'w'
            }}
          </div>
          <div class="info">
            佣金比例 {{ jobInfo.commissionRate + '% | ' }} 保证期
            {{ jobInfo.warranty + ' | ' }} 分成比例 {{ jobInfo.payRules }}
          </div>
          <div class="ipnutBox">
            <div class="title">客户公司</div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-select
                  v-model="jobInfo.customCompanyId"
                  placeholder="请选择客户公司"
                >
                  <el-option
                    :label="item.customCompanyFullName"
                    v-for="(item, index) in companylist"
                    :key="index"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">职位类型</div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-cascader
                  placeholder="请选择职位类型"
                  :options="jobTypeOptions"
                  :show-all-levels="false"
                  v-model="ggg"
                  @change="changejobType"
                ></el-cascader>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">职位名称</div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input
                  width="300"
                  v-model="jobInfo.positionName"
                  placeholder="请输入职位名称"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">职位标签</div>
            <div class="inputCont">
              <el-checkbox-group v-model="jobTags" size="mini">
                <el-checkbox label="优" border>是否预付</el-checkbox>
                <el-checkbox label="独" border>是否独家</el-checkbox>
                <el-checkbox label="急" border>是否加急</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">人选必备项</div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input
                  width="300"
                  v-model="jobInfo.personSelEssential"
                  placeholder="请输入职位人选必备项"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">人选核心项</div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input
                  width="300"
                  v-model="jobInfo.personSelCore"
                  placeholder="请输入职位人选核心项"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">人选加分项</div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input
                  width="300"
                  v-model="jobInfo.personSelBonuspoint"
                  placeholder="请输入职位人选加分项"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">面试流程</div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input
                  width="300"
                  v-model="jobInfo.interviewProcess"
                  placeholder="请输入职位面试流程"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">工作时间</div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input
                  width="300"
                  v-model="jobInfo.workHours"
                  placeholder="请输入职位工作时间"
                ></el-input>
              </div>
            </div>
          </div>

          <div class="ipnutBox">
            <div class="title">月薪范围</div>
            <div class="inputCont">
              <el-input-number
                size="small"
                v-model="jobInfo.salaryMin"
                @change="goeditsalaryMin"
                :min="1"
              ></el-input-number
              ><span> k~ </span>
              <el-input-number
                size="small"
                v-model="jobInfo.salaryMax"
                @change="goeditsalaryMax"
                :min="1"
              ></el-input-number
              ><span> k</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">薪资月份</div>
            <div class="inputCont">
              <el-input-number
                size="small"
                v-model="jobInfo.numberSalary"
                :min="12"
                @change="goeditnumberSalary"
              ></el-input-number
              ><span> 薪</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">年度奖金</div>
            <div class="inputCont">
              <el-input-number
                size="small"
                v-model="jobInfo.bonus"
                :min="0"
                @change="goeditbonus"
                :step="0.01"
              ></el-input-number
              ><span> w</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">工作年限</div>
            <div class="inputCont">
              <el-input-number
                size="small"
                v-model="jobInfo.workingLifeMin"
                @change="goeditworkingLifeMin"
                :min="0"
                :max="11"
              ></el-input-number
              ><span> 年~ </span>
              <el-input-number
                size="small"
                v-model="jobInfo.workingLifeMax"
                @change="goeditworkingLifeMax"
                :min="0"
                :max="11"
              ></el-input-number
              ><span> 年</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">岗位职责</div>
            <div class="inputCont">
              <el-input
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="jobInfo.postDuties"
              >
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">岗位要求</div>
            <div class="inputCont">
              <el-input
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="jobInfo.postReQuirements"
              >
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">特殊说明（非必填）</div>
            <div class="inputCont">
              <el-input
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="jobInfo.des"
              >
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              是否隐藏公司名称
              <el-switch
                v-model="isCompany"
                active-text="隐藏"
                inactive-text="不隐藏"
                @change="changeisCompany"
              >
              </el-switch>
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input
                  width="300"
                  v-model="jobInfo.companyNameCustom"
                  placeholder="请输入匿名之后显示的公司代称"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="btnBox">
            <el-button round @click="goSave">保存编辑并发布</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
  name: 'editPost',
  props: {},
  data() {
    return {
      id: '',
      jobInfo: false,
      jobTypeOptions: [],
      isCompany: false,
      jobTags: [],
      companylist: [],
      ggg: ''
    }
  },
  watch: {},
  created: function () {
    this.id = this.$route.query.id
    this.getPostInfo()
    this.getTopList()
    this.getJobTypeArray()
  },
  methods: {
    getTopList: function () {
      let that = this
      let data = {
          pageNum: 1,
          pageSize: 100,
      }
      axios({
          method: 'POST',
          url: Config.path + '/api/enterprise/custom/company/getList',
          headers: {
              token: localStorage.getItem('token'),
              'content-type': 'application/json'
          },
          data: data,
      }).then((res) => {
          if (res.data.success === '1') {
              let demoList = res.data.content.list
              that.companylist = demoList
            //   that.jobInfo.setompanylist = demoList[0].id
          }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
              that.$message.error(res.data.message);
          }
      }).catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    changeisCompany: function (e) {
      if (e) {
        this.jobInfo.isCompany = '1'
      } else {
        this.jobInfo.isCompany = '0'
      }
    },
    getJobTypeArray: function () {
      let that = this
      axios({
        method: 'GET',
        url: Config.path + '/api/common/treedata/gettreeData',
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.gsArray(res.data.content)
          }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    gsArray: function (list) {
      for (let i in list) {
        let item = list[i]
        item.label = item.name
        item.value = item.name + ',' + item.code
        if (item.childrenlist) {
          item.children = item.childrenlist
          for (let j in item.children) {
            let item2 = item.children[j]
            item2.label = item2.name
            item2.value = item2.name + ',' + item2.code
            if (item2.childrenlist) {
              item2.children = item2.childrenlist
              for (let k in item2.children) {
                let item3 = item2.children[k]
                item3.label = item3.name
                item3.value = item3.name + ',' + item3.code
              }
            }
          }
        }
      }
      this.jobTypeOptions = list
    },
    changejobType: function (e) {
      this.jobInfo.jobTypeCode = e[e.length - 1].split(',')[1]
      this.jobInfo.jobType = e[e.length - 1].split(',')[0]
    },
    getPostInfo: function () {
      let that = this
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/jobinfo/getjobDetail',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          jobid: that.id,
        },
      })
        .then((res) => {
          if (res.data.success === '1') {
            this.jobInfo = res.data.content
            this.jobTags = res.data.content.label
              ? res.data.content.label.split(':')
              : []
            this.value = [
              res.data.content.minYearSalary,
              res.data.content.maxYearSalary,
            ]
            this.isCompany = res.data.content.isCompany === '1' ? true : false
            that.ggg = res.data.content.jobType + ',' + res.data.content.jobTypeCode
          }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    goeditsalaryMin: function (e) {
      if (e <= this.jobInfo.salaryMax) {
        this.jobInfo.salaryMin = e
      } else {
        this.jobInfo.salaryMin = this.jobInfo.salaryMax = e
      }
      this.sumYearSalary()
    },
    goeditsalaryMax: function (e) {
      if (e >= this.jobInfo.salaryMin) {
        this.jobInfo.salaryMax = e
      } else {
        this.jobInfo.salaryMin = this.jobInfo.salaryMax = e
      }
      this.sumYearSalary()
    },
    goeditnumberSalary: function (e) {
      this.jobInfo.numberSalary = e
      this.sumYearSalary()
    },
    goeditbonus: function (e) {
      this.jobInfo.bonus = e
      this.sumYearSalary()
    },
    sumYearSalary: function () {
      ;(this.jobInfo.minYearSalary =
        (Number(this.jobInfo.salaryMin * this.jobInfo.numberSalary) * 10) /
        100),
        (this.jobInfo.maxYearSalary =
          Number(
            (Number(this.jobInfo.salaryMax * this.jobInfo.numberSalary) * 10) /
              100
          ) + Number(this.jobInfo.bonus))
    },
    goeditworkingLifeMin: function (e) {
      if (e <= this.jobInfo.workingLifeMax) {
        this.jobInfo.workingLifeMin = e
      } else {
        this.jobInfo.workingLifeMin = this.jobInfo.workingLifeMax = e
      }
    },
    goeditworkingLifeMax: function (e) {
      if (e >= this.jobInfo.workingLifeMin) {
        this.jobInfo.workingLifeMax = e
      } else {
        this.jobInfo.workingLifeMin = this.jobInfo.workingLifeMax = e
      }
    },
    goSave: function () {
      this.goCopy()
    },
    goCopy: function (index) {
      let that = this
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/jobinfo/copyJob',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          jobid: this.id,
        },
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.jobInfo.id = res.data.content.id
            that.goSaveEdit()
          }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    goSaveEdit: function () {
      let that = this
      this.jobInfo.label = this.jobTags.join(':')
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/jobinfo/editJob',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: this.jobInfo,
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.goOnline()
          }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    goOnline: function () {
      let that = this
      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/jobinfo/upJob',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          jobid: this.jobInfo.id,
        },
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.$message.success('该职位编辑成功并上架')
            that.$router.push({
              path: '/myPost',
            })
          }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
  },
  mounted: function () {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.editPostIndex2 {
  min-width: 100vw;
  flex: 1;
  padding-top: 1px;
  position: relative;
  background-color: #e6e6e6;
  overflow-x: auto;

  .cont {
    width: 90vw;
    background-color: #fff;
    border-radius: 20px;
    margin: 30px auto 0 auto;
    box-sizing: border-box;
    padding: 30px;
    height: calc(100%);
    border-radius: 8px;
    box-sizing: border-box;
    // overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    .topBox {
      .name {
        color: #5dc2d0;
        font-size: 32px;
        font-weight: bold;
        padding-bottom: 10px;
        border-bottom: 2px solid #5dc2d0;

        span {
          font-size: 12px;
        }
      }

      .info {
        padding-top: 10px;
        font-size: 12px;
        color: #5dc2d0;
        width: max-content;
        border-bottom: 2px solid #5dc2d0;
        padding-bottom: 10px;
      }

      .ipnutBox {
        * {
          // background-color: transparent;
          color: #5dc2d0;
          // outline: none;
        }

        .title {
          color: #5dc2d0;
          padding: 20px 0;
        }

        .inputCont {
          .posNameBox {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            span {
              margin: 0 10px 0 20px;
            }

            .el-input {
              width: 300px;
            }
          }
        }
      }

      .btnBox {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        button {
          background-color: transparent;
          color: #5dc2d0;
        }
      }
    }
  }
}
</style>
